const apis = {
  // eslint-disable-next-line no-undef
  BASE: process.env.REACT_APP_API_ENDPOINT,

  LOGIN: `/api/v1/auth/token`,

  REFRESH_TOKEN: `/api/v1/auth/token/refresh`,

  FORGET_PASS: `/api/v1/accounts/password-reset`,

  FORM_LIST: `/api/v1/apa`,

  STATIC: `/api/v1/static-data`,

  PLANING: `/api/v1/apa-planning`,

  EVALUATION: `/api/v1/apa-evaluation`,

  EVALUATION_SEMESTER: `/api/v1/apa-evaluation-semester-wise`,

  UPLOAD: `/api/v1/attachments`,

  FACULTIES: `/api/v1/users`,

  PLANNING_ADMIN: `/api/v1/apa-planning-admin`,

  EVALUATION_ADMIN: `/api/v1/apa-evaluation-admin`,
  
  EVALUATION_SEMESTER_WISE_ADMIN: `/api/v1/apa-evaluation-semester-wise-admin`,

  EVALUATION_FORM: `/api/v1/evaluate-form`,

  CUMUlATIVE_APA: `/api/v1/cumulative-apa-point`,

  COMPLETED_PLANNING_MODULE: `/api/v1/completed-planning-module`,

  APA_RESULT: `/api/v1/apa-result`,

  APA_RESULTS_FACULTY_ADMIN: `/api/v1/apa-result-admin`,

  USER_PROFILE: `/api/v1/users`,

  APA_RESULT_COMMENT: `/api/v1/apa-result-comment`,

  FACULTY_PUBLICATION_COUNT: `/api/v1/faculty-publication-count`,
};

export default apis;
